var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.125,
    y: 7.125,
    width: 23.75,
    height: 23.75,
    rx: 11.875,
    fill: "#7762DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3931 22.2578H19.4931V22.1578V22.0893C19.5047 21.3861 19.6031 20.8935 19.8169 20.5023C20.0302 20.112 20.3646 19.8112 20.8712 19.5038C21.9252 18.8643 22.556 17.9441 22.556 16.621C22.556 15.6935 22.2097 14.8861 21.5933 14.3112C20.9774 13.7365 20.0984 13.4 19.0423 13.4C18.0755 13.4 17.1979 13.6951 16.5501 14.249C15.9011 14.804 15.489 15.6136 15.447 16.6284L15.4426 16.7325H15.5469H17.055H17.1482L17.1547 16.6395C17.1998 15.9932 17.449 15.5456 17.7927 15.2586C18.1382 14.9701 18.5875 14.8368 19.0423 14.8368C20.0855 14.8368 20.9063 15.5077 20.9063 16.5632C20.9063 17.4309 20.4087 18.05 19.739 18.4541C19.168 18.7975 18.6975 19.1461 18.3704 19.6951C18.0437 20.2436 17.8669 20.9802 17.8551 22.0874V22.0885V22.1578V22.2578H17.9551H19.3931ZM18.7267 25.6909C19.3654 25.6909 19.8905 25.1733 19.8905 24.539C19.8905 23.9048 19.3654 23.3871 18.7267 23.3871C18.0906 23.3871 17.5511 23.9023 17.5628 24.539C17.5511 25.1757 18.0906 25.6909 18.7267 25.6909Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support_icon.8e103432d4775e3bd3cdc2acc82c2686.svg";
export { ForwardRef as ReactComponent };